import { BULK_ACTION_TYPES } from '../../timekeepingConstants';

export const getPrimaryButtonText = (bulkActionType) =>
  (bulkActionType === BULK_ACTION_TYPES.RESOLVE &&
    'timekeeping.batchActionModal.resolve.actionButton') ||
  (bulkActionType === BULK_ACTION_TYPES.APPROVE &&
    'timekeeping.batchActionModal.approve.actionButton') ||
  (bulkActionType === BULK_ACTION_TYPES.FINALIZE &&
    'timekeeping.batchActionModal.finalize.actionButton');

export const getApiRoute = (bulkActionType) =>
  (bulkActionType === BULK_ACTION_TYPES.RESOLVE && 'v3/timecards/resolve') ||
  (bulkActionType === BULK_ACTION_TYPES.APPROVE && 'v3/timecards/approve') ||
  (bulkActionType === BULK_ACTION_TYPES.FINALIZE && 'v3/timecards/finalize');

/**
 * This processes the documents from a response of a timecards read response
 * @param {*} documents
 * @returns listOfIds
 */
export const getIdsOfTimecardsFromReadApiDocuments = (documents) =>
  documents?.reduce((accumulator, currentValue) => {
    const additionalIds = currentValue?.timecards?.length
      ? currentValue?.timecards.map((timecard) => timecard.placementId)
      : [];
    return [...accumulator, ...additionalIds];
  }, []);
